import { createFileRoute, useParams } from '@tanstack/react-router';
import { InvoiceFormPage } from '@/pages/Invoice/InvoiceFormPage';
import { Skeleton } from '@/components/ui/skeleton';
import { useInvoiceDetail } from '@/hooks/useInvoices';

function EditInvoiceRoute() {
  const { invoiceId } = useParams({ from: '/_admin/invoice/$invoiceId/edit' });
  const { data: invoice, isLoading, isError } = useInvoiceDetail(invoiceId);

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4 p-6">
        <Skeleton className="h-10 w-72" />
        <Skeleton className="h-64 w-full" />
        <Skeleton className="h-40 w-full" />
      </div>
    );
  }
  if (isError || !invoice) {
    return <p className="p-6 text-base text-danger">Invoice not found.</p>;
  }
  return <InvoiceFormPage invoice={invoice} startInEdit />;
}

export const Route = createFileRoute('/_admin/invoice/$invoiceId/edit')({
  component: EditInvoiceRoute,
});
